<template>
    <div v-show="visible">
        <el-dialog title="查看通知人" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="800px">
            <div style="margin-bottom:10px;">
                <el-input v-model="form.name" placeholder="请输入姓名" clearable style="width:160px;"></el-input>
                <el-input v-model="form.gradeName" placeholder="请输入年级名称" clearable style="width:160px;margin-left:10px;"></el-input>
                <el-input v-model="form.className" placeholder="请输入班级名称" clearable style="width:160px;margin-left:10px;"></el-input>
                <el-button type="primary" style="margin-left:10px;" @click="common.page = 1;getData()">查询</el-button>
            </div>
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="300"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border fit highlight-current-row>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="姓名" width="100"></el-table-column>
                <el-table-column prop="gradeName" label="年级名称" width="120"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="120"></el-table-column>
                <el-table-column prop="readSign" label="阅读标记" width="90">
                    <template slot-scope="scope">
                        <span v-if="scope.row.readSign == 2" style="color:#67C23A;">已读</span>
                        <span v-else-if="scope.row.readSign == 1" style="color:red;">未读</span>
                    </template>
                </el-table-column>
                <el-table-column prop="gmtCreate" label="生成时间"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import http from '@/common/http';

    export default {
        name:"",
        data(){
            return{
                visible:false,
                loading:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100] //每页条数筛选
                },
                form:{
                    patrolId:"",
                    name:"",
                    gradeName:"",
                    className:""
                },
                data:[]
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(id){
                this.visible=true;
                this.form.patrolId=id;
                this.form.name="";
                this.form.gradeName="";
                this.form.className="";
                this.common.page=1;

                this.getData();
            },
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.patrolSendUserListUrl;
                let data = {
                    isPage: this.common.isPage,
                    page: this.common.page,
                    limit: this.common.pageSize,
                    patrolId: this.form.patrolId,
                    name: this.form.name,
                    gradeName: this.form.gradeName,
                    className: this.form.className
                };
                // console.log("请求参数："+JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total = res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/patrol/sendUserInfo.vue